import React from 'react';

const LegalMentions = () => (
    <div className="conteneur">
        <div className="texte">
            <b>Mentions légales</b>
            <p>INTER MUTUELLES ASSISTANCE TECHNOLOGIES</p>
            <p>Société par Actions Simplifiée</p>
            <p>LE SQUARE,</p>
            <p>31 Route de Gachet</p>
            <p>44300 NANTES</p>
            <p>Tél : 02 51 86 62 00</p>
            <p>N° SIRET : 353-259-922-00048</p>
            <p>Code APE : 6202 A Conseil en Systèmes et logiciels Informatiques</p>
            <p>Capital social : 500 000 euros</p>
            <p>RCS Nantes : 353.259.922</p>
            <p>Numéro TVA Intracommunautaire : FR07 353 259 922</p>
            <p>Directeur de la publication : Gérard DACOSTA</p>
        </div>
    </div>
);
export default LegalMentions;